import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslationPipe } from "@modules/core/pipes/translation-pipe/translation.pipe";
import { MarkdownTranslationPipe } from "./markdownTranslation.pipe";

@NgModule({
	declarations: [TranslationPipe, MarkdownTranslationPipe],
	imports: [CommonModule],
	exports: [TranslationPipe, MarkdownTranslationPipe]
})
export class TranslationPipeModule {}
